export default __webpack_public_path__ + "static/media/icon-cloud-server-round.61e2f0f0.svg";